import script from "./iframe.vue?vue&type=script&setup=true&lang=js"
export * from "./iframe.vue?vue&type=script&setup=true&lang=js"

import "./iframe.vue?vue&type=style&index=0&id=e8da79e6&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8da79e6"]])

export default __exports__